import { createContext, useContext } from 'react';

export const ExternalLinkScreenreaderSuffixContext = createContext<string | undefined>(undefined);

type UseExternalLinkScreenreaderSuffixContext = () => string | undefined;
export const useExternalLinkScreenreaderSuffixContext: UseExternalLinkScreenreaderSuffixContext = () =>
  useContext(ExternalLinkScreenreaderSuffixContext);
